import React from 'react';
import { AuthenticationContext } from './types';
import { authenticationContext } from './provider';

function useAuthentication(): AuthenticationContext {
  const context = React.useContext(authenticationContext);

  if (!context) {
    throw new Error(
      'useAuthentication may only be used within the AuthenticationProvider, did you forget to include it?'
    );
  }

  return context;
}

export { useAuthentication };
